import { memo } from "react";
import useSelectView from "../../hooks/useSelectView";
import { ViewType } from "../../assets/constants";
import TradePanelContainer from "./tradePanelContainer";
import TradePanelContainerV2 from "./tradePanelContainerV2";

const TradeWidget: React.FC = () => {
    const view = useSelectView()
    if (view === ViewType.SIMULATOR) {
        return <TradePanelContainer />
    }
    return <TradePanelContainerV2 />;
}

export default memo(TradeWidget);

